import { render } from "./KinjiroSmallIcon.vue?vue&type=template&id=a52ac20c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__